import { filter, map, withLatestFrom } from 'rxjs';
import { assistantState$ } from './assistantState$';
import { isForActiveExchange } from './utils';
import { websocketChatPlanEvent$ } from './websocketStreams$';

export const activePlanEvent$ = websocketChatPlanEvent$.pipe(
  withLatestFrom(assistantState$),
  filter(isForActiveExchange),
  map(([event]) => event)
);
